




































import { Component, Vue } from 'vue-property-decorator'
import { Article, PagingArticle } from '@/model/article/article'
import { articlePaging } from '@/api/article/article'
import { getFormateTime } from '@/apps/ice/utils/date'
@Component
export default class HotArticle extends Vue {
  private hotArticles: Article[] = []
  // private orderByType: string = 'LIKE'
  private pageSize: number = 10
  private pagination: number = 0
  async mounted() {
    this.getArticles()
  }
  // 下一页
  nextPage() {
    this.hotArticles = []
    this.pagination++
    this.getArticles()
  }
  async getArticles() {
    let pagingArticle: PagingArticle = await articlePaging({
      // orderByType: this.orderByType,
      pageSize: this.pageSize,
      pagination: this.pagination
    })
    this.hotArticles = pagingArticle.data
  }
  // 去文章详情页
  goToDetail(article: Article) {
    window.open(`https://ham.youkeda.com/articles/detail/${article.id}`)
  }
  getTime(article: Article) {
    if (!article.articleSource || !article.articleSource.originalGmtCreated) {
      return ''
    }
    let gmtCreated = new Date(article.articleSource.originalGmtCreated)
    let gmtCreatedMs = gmtCreated.getTime()
    let nowTime = new Date().getTime()

    let duringTime = (nowTime - gmtCreatedMs) / 1000
    return getFormateTime(gmtCreated, duringTime)
  }
}
